import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { AddFBRBuyerApi } from "./FBRBuyerAction";
import { GetFBRCompanyApi } from "../FBRCompany/FBRCompanyAction";
import { setHeading } from "../../../accounts/account.actions";
import { Button } from "@mui/material";
import Select from "react-select";
import SendIcon from "@mui/icons-material/Send";


const FBRAddBuyer = (props) => {
    const initialFormState = {
        businessName: "",
        contact: "",
        registrationNo: "",
        strn: "",
        address: ""
    };
    const [form, setForm] = useState(initialFormState);
    const [companyId, setCompanyId] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [province, setProvince] = useState();
    const [registrationType, setRegistrationType] = useState();

    useEffect(() => {
        props.setHeading("Add Buyer");
        props.GetFBRCompanyApi()
    }, []);

    const handleChange = (field) => (e) => {
        setForm({ ...form, [field]: e.target.value });
    };

    function SaveBuyer() {
        props.AddFBRBuyerApi({
            ...form,
            province,
            registrationType,
            companyId,
            companyName,
        },
            showSuccessAlert,
            showErrorAlert
        );
        setForm(initialFormState);
        setCompanyId("");
        setCompanyName("");
        setRegistrationType("");
        setProvince("");
    }

    const handleChangeCompany = (selectedOption) => {
        setCompanyId(selectedOption.value);
        setCompanyName(selectedOption.label);
    };
    const CompanyList = props.FBRCompanyDataList?.length ? props.FBRCompanyDataList.map(x => ({
        value: x._id,
        label: x.companyName
    })) : [];


    let provinces = [{
        value: "PUNJAB",
        label: "PUNJAB"
    },
    {
        value: "BALOCHISTAN",
        label: "BALOCHISTAN"
    },
    {
        value: "AZAD JAMMU AND KASHMIR",
        label: "AZAD JAMMU AND KASHMIR"
    },
    {
        value: "CAPITAL TERRITORY",
        label: "CAPITAL TERRITORY"
    },
    {
        value: "KHYBER PAKHTUNKHWA",
        label: "KHYBER PAKHTUNKHWA"
    },
    {
        value: "SINDH",
        label: "SINDH"
    },
    {
        value: "GILGIT BALTISTAN",
        label: "GILGIT BALTISTAN"
    }];
    const handleChangeProvince = (selectedOption) => {
        setProvince(selectedOption.label);
    };
    const GetProvinceList = provinces.map((x) => {
        let data = { value: x.value, label: x.label };
        return data;
    });


    let registrationTypes = [{
        value: "Registered",
        label: "Registered"
    },
    {
        value: "Unregistered",
        label: "Unregistered"
    }];
    const handleChangeRegistrationType = (selectedOption) => {
        setRegistrationType(selectedOption.label);
    };
    const GetRegistrationTypeList = registrationTypes.map((x) => {
        let data = { value: x.value, label: x.label };
        return data;
    });

    return (
        <>
            {props.isAddingFBRBuyer || props.isFetchingFBRCompany ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Company *</b></Form.Label>
                                    <Select
                                        // placeholder="Select Company"
                                        onChange={handleChangeCompany}
                                        options={CompanyList}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Business Name *</b></Form.Label>
                                    <Form.Control
                                        // placeholder="Business Name"
                                        value={form.businessName}
                                        onChange={handleChange("businessName")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Contact No. </b></Form.Label>
                                    <Form.Control
                                        // placeholder="Contact No."
                                        value={form.contact}
                                        onChange={handleChange("contact")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>NTN / CNIC / Registration No. *</b></Form.Label>
                                    <Form.Control
                                        // placeholder="NTN / CNIC / Registration No."
                                        value={form.registrationNo}
                                        onChange={handleChange("registrationNo")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Province *</b></Form.Label>
                                    <Select
                                        // placeholder="Select Province"
                                        onChange={handleChangeProvince}
                                        options={GetProvinceList}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Registration Type *</b></Form.Label>
                                    <Select
                                        // placeholder="Select Registration Type"
                                        onChange={handleChangeRegistrationType}
                                        options={GetRegistrationTypeList}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Sales Tax No. (STRN) </b></Form.Label>
                                    <Form.Control
                                        // placeholder="Sales Tax No. (STRN)"
                                        value={form.strn}
                                        onChange={handleChange("strn")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Address *</b></Form.Label>
                                    <Form.Control
                                        // placeholder="Address"
                                        value={form.address}
                                        onChange={handleChange("address")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="sendDiv" >
                            <Button variant="contained" endIcon={<SendIcon />} size="large"
                                disabled={isEmpty(companyId) || isEmpty(form.businessName) || isEmpty(form.registrationNo) || isEmpty(province) || isEmpty(registrationType) || isEmpty(form.address)}
                                onClick={SaveBuyer}
                            >
                                SAVE
                            </Button>
                        </div>

                    </Form>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    AddFBRBuyerApi: (data, success, error) => dispatch(AddFBRBuyerApi(data, success, error)),
    GetFBRCompanyApi: () => dispatch(GetFBRCompanyApi()),
    setHeading: (data) => dispatch(setHeading(data)),
});

const mapStateToProps = (state) => ({
    isAddingFBRBuyer: state.FBRBuyerReducer.isAddingFBRBuyer,
    isFetchingFBRCompany: state.FBRCompanyReducer.isFetchingFBRCompany,
    FBRCompanyDataList: state.FBRCompanyReducer.FBRCompanyDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(FBRAddBuyer);